var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-avatar",class:{
    'large': _vm.type === 'large'
  },style:('background-color: ' +
      (_vm.name === 'route_person' ? '#819F77' : _vm.name === 'route_group' ? '#77A9D7' : '#CC2F2F') +
      ';')},[_c('img',{style:(_vm.imgStyle),attrs:{"src":_vm.imgUrl,"alt":"img"}})])}
var staticRenderFns = []

export { render, staticRenderFns }